import PendingInvite from './PendingInvite.component';

export default PendingInvite;
